import { render, staticRenderFns } from "./terminal_transfer.vue?vue&type=template&id=ac51cada&scoped=true"
import script from "./terminal_transfer.vue?vue&type=script&lang=js"
export * from "./terminal_transfer.vue?vue&type=script&lang=js"
import style0 from "./terminal_transfer.vue?vue&type=style&index=0&id=ac51cada&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac51cada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac51cada')) {
      api.createRecord('ac51cada', component.options)
    } else {
      api.reload('ac51cada', component.options)
    }
    module.hot.accept("./terminal_transfer.vue?vue&type=template&id=ac51cada&scoped=true", function () {
      api.rerender('ac51cada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/terminal_transfer.vue"
export default component.exports